import { GzDialogWebComponent } from './component/GzDialogWebComponent';
import { WEB_COMPONENT_GZ_DIALOG } from '../../webcomponents.constants';
import { GzDialogNotificationContentWebComponent } from './dialogContentTemplates/notificationTemplate/GzDialogNotificationContentWebComponent';

export { GzDialogWebComponent, GzDialogNotificationContentWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_DIALOG, GzDialogWebComponent);
